export default {
    getSubscribe(state) {
        return state.subscribe;
    },
    getRoomsSubscribe(state) {
        return state.roomsSubscribe;
    },
    getRoomsCursor(state) {
        return state.roomsCursor;
    },
    getRoomsPageLoaded(state) {
        return state.roomsPageLoaded;
    },
    getCurrentMessagesRoomId(state) {
        return state.currentMessagesRoomId;
    },
    getRoomMessagesCursor(state) {
        return state.roomMessagesCursor;
    },
    getRoomMessagesPageLoaded(state) {
        return state.roomMessagesPageLoaded;
    },
    getRooms(state) {
        return state.rooms;
    },
    getRoomsForFirstTime(state) {
        return state.roomsForFirstTime;
    },
    getActiveRoom(state) {
        return state.activeRoom;
    },

    getRoomIds(state) {
        return state.roomIds;
    },

    getRoomMessages(state) {
        return state.roomMessages;
    },
    getRoomMessagesForFirstTime(state) {
        return state.roomMessagesForFirstTime;
    }
};
